"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVehicleBrandStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const Option_1 = __importDefault(require("../../components/Form/Select/Option"));
exports.useVehicleBrandStore = (0, pinia_1.defineStore)('vehicleBrandStore', {
    state: () => ({
        vehicleBrands: [],
        selectedVehicleBrand: null
    }),
    getters: {
        vehicleBrandOptions: (state) => {
            return state.vehicleBrands.map((vehicleBrand) => {
                return new Option_1.default(vehicleBrand['@id'], vehicleBrand.name, false);
            });
        },
        selectedVehicleBrandModelOptions: (state) => {
            if (state.selectedVehicleBrand === null) {
                return [];
            }
            return state.selectedVehicleBrand.vehicleModels.map((vehicleModel) => {
                return new Option_1.default(vehicleModel['@id'], vehicleModel.name, false);
            });
        }
    },
    actions: {
        getVehicleBrands(router, params = {}) {
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_vehicle_brands_api', query: params }).href)
                    .then((response) => {
                    let vehicleBrands = [];
                    if (Array.isArray(response['hydra:member'])) {
                        response['hydra:member'].forEach(element => {
                            if (element['@type'] !== 'VehicleBrand') {
                                return;
                            }
                            vehicleBrands.push(element);
                        });
                    }
                    this.vehicleBrands = vehicleBrands;
                    resolve(response);
                })
                    .catch(error => {
                    reject(error);
                });
            });
        },
    },
});
